<template>
<loader v-bind="{ loading }">
  <page-navigation :title="`${team.name}`"/>
</loader>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  data: () => ({
    loading: true
  }),

  created() {
    this.$store.dispatch('app/loadTeam', this.$route.params.app).finally(() => {
      this.loading = false
    })
  },

  computed: {
    ...mapGetters('app', [
      'team'
    ])
  }

}
</script>